import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./style.scss";
class TagRedBlock extends Component {
  render() {
    return (
      <Link
        to={this.props.linkUrl}
        onClick={this.props.onClick}
        className={`mt-2 item-tag ${this.props.class}`}
      >
        <div>{this.props.tag.name}</div>
      </Link>
    );
  }
}

export default TagRedBlock;
